<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('yearBook.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('yearBook.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-w-full ts-relative" style="height: 80vh">
          <ts-button
            @click="onShowModal"
            class="ts-absolute ts-z-50 ts-m-2"
            color="info"
            >{{ $t('view') }}</ts-button
          >
          <img
            :src="backgroundImg"
            alt=""
            class=" ts-absolute ts-opacity-25 ts-z-0"
          />
          <div
            class="ts-w-full ts-h-full ts-z-20"
            style="background-color: rgb(255 255 255 / 0.3); backdrop-filter: blur(6px);"
          ></div>
          <div
            class="ts-w-full ts-h-full ts-z-40 ts-absolute ts-top-0 ts-left-0 ts-overflow-y-scroll"
            v-if="!isEmpty(exhibition)"
          >
            <div style="width: fit-content;" class="ts-m-auto ts-text-center">
              <h1 class="ts-font-extrabold ts-font-teko ts-text-4xl">
                {{ showAcademicYear }}
              </h1>
              <h1 class="ts-font-extrabold ts-font-teko ts-text-xl">
                Class of Academic Year: {{ showAcademicClass }}
              </h1>
            </div>
            <ImageFrame
              :image="exhibition.teacher ? exhibition.teacher.photo : ''"
              :name="exhibition.teacher ? exhibition.teacher.full_name_en : ''"
              class="ts-m-auto ts-mt-8"
            />
            <br />
            <br />
            <div
              class="ts-grid ts-grid-cols-2 sm:ts-grid-cols-5 ts-gap-16 ts-m-auto"
              style="width: fit-content;"
            >
              <ImageFrame
                v-for="(s, index) in exhibition.students"
                :key="index"
                :image="s.photo"
                :name="s.full_name_en"
                :dob="s.date_of_birth ? s.date_of_birth : 'N/A'"
                :sex="s.gender"
              />
            </div>
          </div>
          <DisplayHolder v-else />
        </div>
      </ts-card-wrapper>
    </ts-card>
    <a-modal v-model="showModal" :centered="true" :footer="null" width="300px">
      <ts-loading-banner :loading="loading">
        <div class="row">
          <div class="col-md-12">
            <div class="ts-grid ts-grid-cols-1 ts-gap-3">
              <div>
                <label class="required">{{
                  $t('yearBook.academicYear')
                }}</label>
                <a-select
                  v-model="model.ac_year_id"
                  :options="
                    acYears.map(el => ({
                      value: el.ac_year_id,
                      label: el.ac_year
                    }))
                  "
                  @change="onFetchClass"
                  class="ts-w-full"
                ></a-select>
              </div>
              <div>
                <label class="required">{{
                  $t('yearBook.academicClass')
                }}</label>
                <a-select
                  v-model="model.class_id"
                  :options="classList"
                  class="ts-w-full"
                  :showSearch="true"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  optionFilterProp="children"
                  @change="onFetchExhibition"
                ></a-select>
              </div>
            </div>
          </div>
        </div>
      </ts-loading-banner>
    </a-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { isEmpty } from 'lodash'
import ImageFrame from './components/imageFram.vue'
import DisplayHolder from './components/displayPlaceHolder.vue'
export default {
  name: 'yearBook',
  components: {
    ImageFrame,
    DisplayHolder
  },
  data() {
    return {
      showModal: false,
      acYears: [],
      academicClass: [],
      exhibition: {},
      loading: false,
      backgroundImg: require('@/assets/year_book.jpg'),
      model: {
        ac_year_id: undefined,
        class_id: undefined
      }
    }
  },
  computed: {
    classList() {
      return this.academicClass.map(el => ({
        value: el.class_id,
        label: el.class_name + ' ' + el.class_desc
      }))
    },
    showAcademicYear() {
      let year = this.acYears.find(y => y.ac_year_id == this.model.ac_year_id)
      if (year) {
        return year.ac_year
      }
      return ''
    },
    showAcademicClass() {
      let classInstance = this.academicClass.find(
        c => c.class_id == this.model.class_id
      )
      if (classInstance) {
        return classInstance.class_name
      }
      return ''
    }
  },
  created() {
    this.fetchFormView()
  },
  methods: {
    ...mapActions('yearBook', ['formView']),
    isEmpty,
    fetchFormView() {
      this.loading = true
      this.formView()
        .then(response => {
          this.acYears = response.acYear
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    onFetchClass() {
      this.loading = true
      this.formView({
        ac_year_id: this.model.ac_year_id,
        fnName: 'acadmicClass'
      })
        .then(response => {
          this.academicClass = response.acadmicClass
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onFetchExhibition() {
      this.loading = true
      this.formView({
        class_id: this.model.class_id,
        fnName: 'exhibition'
      })
        .then(response => {
          this.exhibition = response.exhibition[0]
          this.showModal = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onShowModal() {
      this.showModal = true
    }
  }
}
</script>
